import gql from 'graphql-tag';

const FRAGMENTS = gql`
    fragment File on files {
        id
        user_id
        original_name
        filename
        object_key
        shared
        created_at
    }
`

export const GET_FILES = gql`
  query GetFiles {
    files {
      ...File
    }
  }
  ${FRAGMENTS}
`


export const GET_SPECIFIC_FILE = gql`
  query GetFiles($userId:Int!) {
    files:files(where:{user_id:{_eq:$userId}}) {
      ...File
    }
  }
  ${FRAGMENTS}
`




export const INSERT_FILE = gql`
    mutation InsertFile($input: files_insert_input!) {
        insert_files_one(object: $input) {
            ...File
        }
    }
    ${FRAGMENTS}
`;

export const UPDATE_FILE = gql`
    mutation UpdateFile($id: uuid!, $file: files_set_input!) {
        update_files_by_pk(pk_columns: { id: $id }, _set: $file) {
            ...File
        }
    }
    ${FRAGMENTS}
`;

export const DELETE_FILE = gql`
    mutation DeleteFile($id: uuid!) {
        delete_files_by_pk(id: $id) {
            id
        }
    }
`;